// extracted by mini-css-extract-plugin
module.exports = {"menu_container":"menu-module--menu_container--lxU1i","menu_box":"menu-module--menu_box--1ob7F"};